<template>

    <div class="w-full min-h-[80vh]">
        <div class="dark:text-gray-400 px-3.5 sm:px-4 md:px-6 lg:px-8 xl:px-20 xl:max-w-[85rem] w-full mx-auto md:pt-8">
            <div class="mx-auto max-w-2xl mb-10">
                <h2 class="text-4xl text-center">Flexible plans and features. Honest pricing. No hidden charges.</h2>
                <p class="text-gray-500 text-center mt-5">Get the payroll, benefits and HR tools your business needs all in one place. Plus, now is the easiest time to switch. And you won't pay a cent until you're ready to run payroll.</p>
            </div>
            <div class="w-full max-w-[59rem] mx-auto flex justify-between items-center bg-white dark:bg-[#22272E] md:bg-transparent z-10">
                <div class="flex items-center  border-gray-300 rounded-[5px] space-x-1">
                    <router-link class="top-link" to="/pricing/individuals" v-slot="{ navigate }">
                        <span class="flex items-center" @click="navigate">
                            <span class="hidden md:flex"> 
                                Individuals
                            </span>
                        </span>
                    </router-link>
                    
                    <router-link class="top-link" to="/pricing/teams-and-organizations" v-slot="{ navigate }">
                        <span class="flex items-center" @click="navigate">
                            
                            <span class="hidden md:flex">
                                Teams &  Organizations
                            </span>
                        </span>
                    </router-link>

                    <router-link class="top-link" to="/pricing/build-with-timelydo" v-slot="{ navigate }">
                        <span class="flex items-center" @click="navigate">
                    
                            <span class="hidden md:flex">
                                Build with TimelyDo
                            </span>
                        </span>
                    </router-link>
                </div>
                <div v-show="individual_index" class="bg-white  text-sm border-gray-300 p-1 rounded-[5px]">
                    <button class="text-gray-500 bg-gray-50 mr-1 px-10 py-2 rounded-[5px]">Monthly</button>
                    <button class="text-gray-800 font-medium bg-blue-100 px-10 py-2 rounded-[5px]">Yearly</button>
                </div>

            </div>
            <div class="w-full">
                
                <div class="my-5">
                    <router-view />
                </div>
            </div>
        </div>
    </div>
  
</template>

<script>
import Constants from "controllers/vue_components/mixins/constants"

export default {
    name: 'PricingIndex',
    props: [],
    mixins: [Constants],
    data() {
        return {
            individual_index: false
        };
    },
    methods: {
        updateIndividualIndex() {
            this.individual_index = window.location.href.includes('/pricing/individuals');
        }
    },
    mounted() {
        this.updateIndividualIndex();
    },
    watch: {
        '$route': 'updateIndividualIndex'
    },
    computed: {},
    created() {
        
    }
};
</script>
